import { v4 as uuidv4 } from 'uuid';

class DeviceManager {
  constructor() {
    this.DEVICE_ID_KEY = 'booking_app_device_id';
    this.DEVICE_NAME_KEY = 'booking_app_device_name';
  }

  getDeviceId() {
    let deviceId = localStorage.getItem(this.DEVICE_ID_KEY);

    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem(this.DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
  }

  getDeviceName() {
    let deviceName = localStorage.getItem(this.DEVICE_NAME_KEY);

    if (!deviceName) {
      deviceName = this.generateDeviceName();
      localStorage.setItem(this.DEVICE_NAME_KEY, deviceName);
    }

    return deviceName;
  }

  setDeviceName(name) {
    localStorage.setItem(this.DEVICE_NAME_KEY, name);
  }

  generateDeviceName() {
    const ua = navigator.userAgent;
    let browser = 'Unknown Browser';
    let os = 'Unknown OS';

    if (ua.includes('Chrome')) browser = 'Chrome';
    else if (ua.includes('Firefox')) browser = 'Firefox';
    else if (ua.includes('Safari')) browser = 'Safari';
    else if (ua.includes('Edge')) browser = 'Edge';

    if (ua.includes('Windows')) os = 'Windows';
    else if (ua.includes('Mac')) os = 'Mac';
    else if (ua.includes('Linux')) os = 'Linux';
    else if (ua.includes('Android')) os = 'Android';
    else if (ua.includes('iOS')) os = 'iOS';

    return `${browser} on ${os}`;
  }

  clearDeviceData() {
    localStorage.removeItem(this.DEVICE_ID_KEY);
    localStorage.removeItem(this.DEVICE_NAME_KEY);
  }

  getDeviceInfo() {
    return {
      deviceId: this.getDeviceId(),
      deviceName: this.getDeviceName(),
      userAgent: navigator.userAgent,
    };
  }
}

const deviceManager = new DeviceManager();
export default deviceManager;
